import * as React from "react";
import { RouteComponentProps } from "react-router";
import { withRouter } from "react-router-dom";
import app from "../../core/application";
import {sendRequest} from "../../helpers/ajax";
import IPasswordIsValidRequest from "../../types/IPasswordIsValidRequest";
import IPasswordIsValidResponse from "../../types/IPasswordIsValidResponse";
import IRegisterRequest from "../../types/IRegisterRequest";
import IRegisterResponse from "../../types/IRegisterResponse";
import IResponse from "../../types/IResponse";
import IUserSession from "../../types/IUserSession";
import IValidateRegistrationKeyRequest from "../../types/IValidateRegisterKeyRequest";
import IValidateRegistrationKeyResponse from "../../types/IValidateRegisterKeyResponse";
import Register from "./Register";

interface IRegisterContainerProps extends RouteComponentProps<any> {
    onLogin: (userSession: IUserSession) => void;
}

class RegisterContainer extends React.Component<IRegisterContainerProps>{

    constructor(props: IRegisterContainerProps) {
        super(props);

        this.validateRegistrationCode = this.validateRegistrationCode.bind(this);
        this.registerUser = this.registerUser.bind(this);
        this.validatePasswordRequirements = this.validatePasswordRequirements.bind(this);
    }

    public render() {
        return (
            <Register 
                validateRegistrationCode={this.validateRegistrationCode} 
                registerUser={this.registerUser}
                validatePasswordRequirements={this.validatePasswordRequirements}
            />
        );
    }

    private validateRegistrationCode(): Promise<IResponse<IValidateRegistrationKeyResponse> | null>  {
        //  Get the registration key from the URL
        const registrationCode = this.props.match.params.registrationCode as string;

        const request: IValidateRegistrationKeyRequest = { registrationCode };
        return sendRequest<IResponse<IValidateRegistrationKeyResponse>>("/api/Register/ValidateKey", "POST", request);
    }

    private async registerUser(password: string, confirmPassword: string, email: string, registrationCode: string): Promise<IResponse<IRegisterResponse> | null> {
        const request: IRegisterRequest = { password, email, registrationCode };
        const response = await sendRequest<IResponse<IRegisterResponse>>("/api/Register/RegisterUser", "POST", request);

        if (response && response.success && response.payload && response.payload.success && response.payload.userSession) {
            // successful login
            app().logInUser(response.payload.userSession);
            this.props.onLogin(response.payload.userSession);
        }
        return response;
    }

    private  validatePasswordRequirements(password: string): Promise<IResponse<IPasswordIsValidResponse> | null>  {
        const request: IPasswordIsValidRequest = { password };
        return sendRequest<IResponse<IPasswordIsValidResponse>>("/api/PasswordRequirements/IsValid", "POST", request);
    }

}

export default withRouter(RegisterContainer);




// WEBPACK FOOTER //
// ./src/components/Register/RegisterContainer.tsx